import WebCollaboration from "./WebCollaboration";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import CollaborationStore from '@/store/collaboration.store';
import summaryCommonStore from '@/store/summaryCommon.store';
import { maxMobileWidth } from "@/constants/share";
import MobileCollaboration from "@/sections/MobileCollaboration";
import http from "@/services/http";
import { setLoginSize } from "@/utils/window";
import useLoginStore from "@/store/login.store";
import { TranslationOption } from "@/constants/translate";
import { RuningInLink } from '@/constants';
import { webConnectMeeting, getMeetingRecordStatus } from "@/services/api_collaboration";

export default function Collaboration() {
  const navigate = useNavigate();
  const { isVisitor } = useLoginStore();
  const queryParams = new URLSearchParams(window.location.search);
  let streamId = queryParams.get("streamId") || "";
  //去除 streamId 中的 live/ 前缀
  streamId = streamId.replace("live/", "");
  const isAuthRedirectRef = useRef(false);
  const setTranslationOption = CollaborationStore((state) => state.setTranslationOption);
  const setMeetingFinish = CollaborationStore((state) => state.setMeetingFinish);
  const meetingFinish = CollaborationStore((state) => state.meetingFinish);

  useEffect(() => {
    // 如果当前页面不是协作页面，则不进行token检查，避免路由切换时的重复执行
    if (!location.pathname.includes('/collaboration')) {
      return;
    }

    const token = http.getToken();
    if (!token && !isVisitor) {
      message.info("请先登录");
      setLoginSize();

      isAuthRedirectRef.current = true;

      const currentUrl = '/collaboration' + location.search;
      const params = { redirectUrl: currentUrl };
      const search = new URLSearchParams(params).toString();
      const loginUrl = `/login?${search}`;

      navigate(loginUrl, { replace: true });
      return;
    }

    if (streamId) {
      summaryCommonStore.getState().setStreamId(streamId);
    }

    //非客户端通过此接口连接会议
    if (!RuningInLink && !isVisitor) {
      const res = webConnectMeeting(streamId);
      if (!res) {
        message.error("连接会议失败");
      }
    }

    // 处理翻译选项参数
    const translationOptionParam = queryParams.get("translationOption");
    const validOptions = Object.values(TranslationOption);

    // 如果参数存在且符合枚举，则使用该值；否则设为只显示原文
    const translationOption = translationOptionParam && validOptions.includes(translationOptionParam as TranslationOption)
      ? translationOptionParam as TranslationOption
      : TranslationOption.original;

    setTranslationOption(translationOption);

    return () => {
      if (isAuthRedirectRef.current) {
        isAuthRedirectRef.current = false;
        return;
      }
      CollaborationStore.getState().init();
    };
  }, [navigate, streamId]);

  // 页面可见性监听：回到前台时检查会议是否结束
  useEffect(() => {
    const handleVisibilityChange = async () => {
      // 只在页面变为可见时检查
      if (!document.hidden && streamId && !meetingFinish) {
        try {
          const fullStreamName = streamId.includes('live/') ? streamId : `live/${streamId}`;
          const res = await getMeetingRecordStatus(fullStreamName);
          if (res && res.isStop) {
            console.log('检测到会议已结束，触发结束流程');
            setMeetingFinish(true);
          }
        } catch (error) {
          console.warn('检查会议状态失败', error);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [streamId, meetingFinish, setMeetingFinish]);

  return (
    <>
      {document.documentElement.clientWidth <= maxMobileWidth ? (
        <MobileCollaboration />
      ) : (
        <WebCollaboration />
      )}
    </>
  );
}
